import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {motion} from 'framer-motion'
import RTE from '@consteed/frontend/components/pageDesigner/RTE'
import {Region, regionPropType} from '@salesforce/commerce-sdk-react/components'

const MotionBox = motion(Box)
const variants = {
    slideIn: {
        // opacity: 1,
        y: 0,
        transition: {
            ease: 'easeInOut',
            duration: 1
        }
    },
    slideInHorse: {
        y: 0,
        transition: {
            ease: 'easeInOut',
            duration: 0.8
        }
    },
    hiddenHorse: {
        y: '30%'
    },
    hiddenButton: {
        y: '40%'
    },
    hiddenText: {
        y: '50%'
    }
}
/**
 * LandingPageInfoWith3DModel component
 *
 * @param {object} props
 * @param {string} - props.headline - Headline beside Image.
 * @param {string} - props.text - Text beside Image.
 * @param {regionType []} props.regions - The page designer regions for this component.
 * @returns {React.ReactElement} - LandingPageInfoWith3DModel component.
 */
const LandingPageInfoWith3DModel = ({headline, text, regions}) => {
    return (
        <Flex
            className={'pdcOuterBox'}
            direction={{base: 'column', md: 'row'}}
            align="center"
            gap={4}
        >
            <Box flex="1">
                <MotionBox variants={variants} initial="hiddenText" whileInView="slideIn">
                    <RTE
                        richText={headline}
                        textStyles={{base: 'light7Xlarge', xl: 'light9Xlarge'}}
                    />
                    <RTE richText={text} textStyles={{base: 'bookLarge', xl: 'book2Xlarge'}} />
                </MotionBox>
            </Box>
            <MotionBox
                variants={variants}
                initial="hiddenHorse"
                whileInView="slideIn"
                flex="1"
                width="100%"
            >
                {regions.map((region) => (
                    <Region key={region.id} region={region} />
                ))}
            </MotionBox>
        </Flex>
    )
}

LandingPageInfoWith3DModel.propTypes = {
    headline: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    regions: PropTypes.arrayOf(regionPropType).isRequired
}

export default LandingPageInfoWith3DModel
